import { usePageMeta } from "@/lib/usePageMeta";
import { useLang } from "@/lib/i18n";
import { LegalPage } from "@/components/LegalPage";

export default function Privacy() {
  const { t } = useLang();
  usePageMeta(t.privacy.meta);
  return <LegalPage data={t.privacy} testId="privacy" />;
}
